<template>
  <div
    :style="{
      height: '100%',
      cursor: item.type == 'marketing' ? 'pointer' : item.variants[0]?.is_out_of_stock ? 'not-allowed' : 'pointer',
    }"
  >
    <div
      v-if="item.type == 'marketing'"
      :style="{
        background: 'url(' + item.image + ') no-repeat center center / cover',
      }"
      class="marketing"
    ></div>
    <div style="height: 100%; display: flex; flex-direction: column; overflow: hidden" v-else>
      <div
        v-if="checkIfImageIsVisible"
        class="itemImageWrapper hidden"
        :class="{ flyToCart: flyToCardItemId == item.item_id }"
      >
        <img
          :src="item.image_urls.thumbnail"
          :alt="item.name"
          loading="lazy"
          :class="{ outOfStock: item.variants[0]?.is_out_of_stock }"
        />
      </div>
      <div v-if="checkIfImageIsVisible" class="itemImageWrapper">
        <img
          :src="item.image_urls.thumbnail"
          :alt="item.name"
          loading="lazy"
          ref="itemImageWrapper"
          :class="{ outOfStock: item.variants[0]?.is_out_of_stock }"
        />
      </div>
      <div class="itemInfo">
        <span class="itemName">{{ item.name }}</span>
        <p class="itemDescription">{{ item.short_desc }}</p>
        <div v-if="item.allergen_ids || item.class_ids" class="allergyIcons">
          <div v-for="(allergen, index) in getUniqueAllergyIcons()" :key="index" class="allergens">
            <p class="allergensNoIcon" v-if="!allergen.icon_url">{{ allergen.display }}</p>
            <img v-if="allergen.icon_url" :src="allergen.icon_url" :alt="allergen.name" class="allergen-icon" />
            <br />
            <div class="tooltip">
              {{ allergen.name }}
            </div>
          </div>
        </div>
        <p v-if="item.variants[0].min_calories && item.variants[item.variants.length - 1].max_calories" class="calorie">
          <span v-if="item.variants[0].min_calories == item.variants[item.variants.length - 1].max_calories"
            >{{ item.variants[0].min_calories }} cals</span
          >
          <span v-else
            >{{ item.variants[0].min_calories }} cals -
            {{ item.variants[item.variants.length - 1].max_calories }}
            cals</span
          >
        </p>
        <div v-if="branding?.display_options?.show_prices_on_menu !== false" class="priceWrapper">
          <h3 v-if="checkIfPriceIsVisible" class="itemPrice">
            {{ formatPrice(getTheLowestPrice(item.variants)) }}
          </h3>
          <div
            v-if="orderData && !getTotalQuantity(item.item_id).totalQuantity && !item.variants[0]?.is_out_of_stock && item.type != 'marketing'"
            @click.stop="getItemData(item, category, 'add', 'quickAdd')"
            class="quickAdd"
            :class="{ fillScreen: fillScreenItemId == item.item_id && fillScreenAnimation && windowWidth <= 500 }"
            ref="quickAddButton"
          >
            <div
              v-if="quickAddLoading && quickAddLoadingItemId == item.item_id"
              class="loader smallLoader"
              :style="{ display: fillScreenItemId == item.item_id && fillScreenAnimation ? 'none' : 'block' }"
            ></div>
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              width="6.033"
              height="6.033"
              viewBox="0 0 6.033 6.033"
              :style="{ display: fillScreenItemId == item.item_id && fillScreenAnimation ? 'none' : 'block' }"
            >
              <path
                id="Path_19847"
                data-name="Path 19847"
                d="M218.614,145.6a.377.377,0,0,0-.377.377v2.262h-2.262a.377.377,0,0,0,0,.754h2.262v2.262a.377.377,0,0,0,.754,
                              0v-2.262h2.262a.377.377,0,0,0,0-.754h-2.262v-2.262A.377.377,0,0,0,218.614,145.6Z"
                transform="translate(-215.598 -145.6)"
              />
            </svg>
          </div>
          <div
            :style="{
              'border-color': qtyLoading ? 'var(--passive-color)' : 'var(--primary-color)',
              'background-color': branding.dark_mode_enabled ? 'var(--primary-color)' : 'var(--text-color)',
            }"
            class="qtyWrapper"
            v-if="orderData && getTotalQuantity(item.item_id).totalQuantity && item.type != 'marketing'"
          >
            <button
              :disabled="qtyLoading && selectedItemId == item.item_id"
              @click.stop="
                item.quantity != 1
                  ? changeQty('minus', item, index)
                  : removeItemClicked(item.order_item_id, item.item_name)
              "
              :style="{
                'border-color': qtyLoading ? 'var(--passive-color)' : 'var(--text-color)',
              }"
              v-if="!getTotalQuantity(item.item_id).multipleItems"
            >
              <template v-if="getTotalQuantity(item.item_id).totalQuantity != 1">-</template>
              <svg
                v-else
                class="delete"
                xmlns="http://www.w3.org/2000/svg"
                width="9.998"
                height="10.774"
                viewBox="0 0 9.998 10.774"
              >
                <path
                  id="Delete_Solid"
                  d="M839.419,2646.771a.766.766,0,0,1-.767-.7l-.693-7.6c0-.025,0-.051,0-.076h-.574a.382.382,0,0,1,0-.764H839.9v-.866a.769.769,0,0,1,.768-.768h2.665a.769.769,0,0,1,.768.768v.866h2.518a.382.382,0,1,1,0,.764h-.574c0,.025,0,.051,0,.076l-.693,7.6a.766.766,0,0,1-.767.7Zm4.132-6.971a.379.379,0,0,0-.12.257l-.229,4.186a.382.382,0,0,0,.361.4h.021a.382.382,0,0,0,.381-.361l.229-4.186a.382.382,0,0,0-.36-.4h-.02a.381.381,0,0,0-.262.1Zm-1.933.278v4.186a.382.382,0,1,0,.764,0v-4.186a.382.382,0,1,0-.764,0Zm-1.451-.381a.382.382,0,0,0-.36.4l.229,4.186a.382.382,0,0,0,.381.361h.021a.382.382,0,0,0,.36-.4l-.229-4.186a.382.382,0,0,0-.382-.361Z"
                  transform="translate(-837.003 -2635.997)"
                />
              </svg>
            </button>
            <div class="qty">
              <div v-if="qtyLoading && selectedItemId == item.item_id" class="loader smallLoader"></div>
              <span v-else>{{ getTotalQuantity(item.item_id).totalQuantity }}</span>
            </div>
            <button
              :disabled="qtyLoading && selectedItemId == item.item_id"
              @click.stop="changeQty('plus', item, index)"
              :style="{
                'border-color': qtyLoading ? 'var(--passive-color)' : 'var(--text-color)',
              }"
              v-if="!getTotalQuantity(item.item_id).multipleItems"
            >
              +
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formattingMixins from '@/mixins/formattingMixins'
import allergensMixins from '@/mixins/allergensMixins'
import menuItemImageVisibility from '@/mixins/menuItemImageVisibility'

import { mapState } from 'vuex'

export default {
  data() {
    return {
      imagePositionTop: null,
      imagePositionLeft: null,
      quickAddLoading: false,
      quickAddButtonTop: null,
      quickAddButtonLeft: null,
      windowWidth: window.innerWidth,
    }
  },
  props: [
    'item',
    'category',
    'index',
    'orderData',
    'qtyLoading',
    'selectedItemId',
    'quickAddLoadingItemId',
    'fillScreenAnimation',
    'fillScreenItemId',
    'flyToCardItemId',
  ],
  mixins: [formattingMixins, allergensMixins, menuItemImageVisibility],
  computed: {
    ...mapState(['storeConfig', 'branding', 'cartButtonTop', 'cartButtonLeft']),
    checkIfPriceIsVisible() {
      if ('hide_price_if_zero' in this.branding?.display_options) {
        if (this.branding?.display_options?.hide_price_if_zero && this.getTheLowestPrice(this.item.variants) === 0) {
          return false
        }
      }
      return true
    },
  },
  methods: {
    getTheLowestPrice(prices) {
      return prices[0]?.display_price
    },
    getTotalQuantity(itemId) {
      let totalQuantity = 0
      let multipleItems = false

      for (let i = 0; i < this.orderData.order.items.length; i++) {
        const item = this.orderData.order.items[i]

        if (item.item_id === itemId) {
          totalQuantity += item.quantity

          if (totalQuantity > item.quantity) {
            multipleItems = true
          }
        }
      }
      return {
        totalQuantity,
        multipleItems,
      }
    },
    getItemData(item, category, action, type) {
      this.quickAddLoading = true
      if (!this.branding.display_options.hide_menu_item_images) {
        this.imagePositionTop = this.$refs.itemImageWrapper.getBoundingClientRect().y + 'px'
        this.imagePositionLeft = this.$refs.itemImageWrapper.getBoundingClientRect().x + 'px'
        this.quickAddButtonTop = this.$refs.quickAddButton.getBoundingClientRect().y + 'px'
        this.quickAddButtonLeft = this.$refs.quickAddButton.getBoundingClientRect().x + 'px'
      }
      this.$emit('getItemData', item, category, action, type)
    },
    changeQty(action, item, index) {
      this.$emit('changeQty', action, item, index)
    },
    getUniqueAllergyIcons() {
      const uniqueAllergenIds = [...new Set(this.item?.allergen_ids)]
      const uniqueClassIds = [...new Set(this.item?.class_ids)]
      return this.getAllergyIcons(uniqueAllergenIds, uniqueClassIds)
    },
  },
  mounted() {
    // add event listener for window resize
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  beforeUnmount() {
    // remove event listener for window resize
    window.removeEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
}
</script>

<style src="../../../assets/css/Main/Menu/ItemCell.css" scoped>
@keyframes flyToCart {
  0% {
    top: v-bind(imagePositionTop);
    left: v-bind(imagePositionLeft);
    width: 300px;
  }
  75% {
    opacity: 1;
  }
  100% {
    top: calc(v-bind(cartButtonTop) + 20px);
    left: calc(v-bind(cartButtonLeft) + 20px);
    width: 0px;
    opacity: 0;
  }
}

@media screen and (min-width: 500px) {
  .fillScreen {
    position: fixed;
    top: v-bind(quickAddButtonTop);
    left: v-bind(quickAddButtonLeft);
    opacity: 0;
    z-index: 999;
    animation-name: fillScreen;
    animation-duration: 0.6s;
    animation-timing-function: linear;
    -webkit-animation-timing-function: linear;
  }

  @keyframes fillScreen {
    0% {
      scale: 1;
      opacity: 1;
    }
    60% {
      opacity: 1;
    }
    90% {
      scale: 100;
    }
    100% {
      opacity: 0;
    }
  }
}

@media screen and (max-width: 500px) {
  .fillScreen {
    position: fixed;
    top: v-bind(quickAddButtonTop);
    left: v-bind(quickAddButtonLeft);
    opacity: 0;
    z-index: 999;
    animation-name: fillScreen;
    animation-duration: 0.5s;
    animation-timing-function: linear;
    -webkit-animation-timing-function: linear;
  }

  @keyframes fillScreen {
    0% {
      scale: 1;
      opacity: 1;
    }
    60% {
      opacity: 1;
    }
    90% {
      scale: 70;
    }
    100% {
      opacity: 0;
    }
  }
}
</style>
